import React, { FC, ReactElement } from 'react';
import { localeStore } from '~/mobx/localesStore';
import { SyncStatus } from '~/constants/integrations';

interface IProps {
  syncInProgress: boolean;
  isFirstSync: boolean;
  syncStatus?: SyncStatus;
  lastSyncDate: string;
}

const FoodicsTopSyncTip: FC<IProps> = (props: IProps): ReactElement | null => {
  if (props.syncInProgress) {
    return null;
  }
  if (props.syncStatus === SyncStatus.FAILED) {
    return <span className="foodics-authorized-form__tip error mt-2">{localeStore.t('t2_foodics_sync_error')}</span>;
  }
  if (!props.isFirstSync) {
    return <span className="foodics-authorized-form__dates">{`${localeStore.t('t2_foodics_last_sync')} ${props.lastSyncDate}`}</span>;
  }
  return null;
};

export default FoodicsTopSyncTip;
